import { IGeneralAttributeResourceCalculationKey } from '../../interfaces/igeneral-attribute-resource-calculation-key';
import { GeneralAttribute } from '../general-attribute';
import { ResourceCalculation } from '../resource-calculation';

export class GeneralAttributeResourceCalculationKeyBase {
  GeneralAttributeResourceCalculationKeyId: number;
  GeneralAttributeId: number;
  ResourceCalculationId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GeneralAttribute?: GeneralAttribute;
  ResourceCalculation?: ResourceCalculation;

  constructor(item?: IGeneralAttributeResourceCalculationKey) {
    if (item) {

      this.GeneralAttributeResourceCalculationKeyId = item.GeneralAttributeResourceCalculationKeyId;
      this.GeneralAttributeId = item.GeneralAttributeId;
      this.ResourceCalculationId = item.ResourceCalculationId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GeneralAttribute = new GeneralAttribute(item.GeneralAttribute);
      this.ResourceCalculation = new ResourceCalculation(item.ResourceCalculation);
    }
  }
}